import axios from "axios";
import {
    DdtDetailsModel,
    DdtsAPIDetailsResponse,
} from "../utils/models/ddt-details";
import {
    GET_DDT_DETAILS_API_ENDPOINT,
    GET_DDT_DETAILS_LIST_API_ENDPOINT,
} from "../utils/constants/api.constants";
import {
    DdtDetailsListItemModel,
    DdtsAPIDetailsListResponse,
} from "../utils/models/ddt-details-list";

export async function getDdtsDetailsAPI(
    ddtId: string,
): Promise<DdtDetailsModel> {
    try {
        const ddtResponse = await axios.get<DdtsAPIDetailsResponse>(
            GET_DDT_DETAILS_API_ENDPOINT(ddtId),
        );

        const ddtResponseData = ddtResponse.data;

        if (ddtResponse.status > 200 || !ddtResponseData) {
            throw ddtResponse;
        }

        return new DdtDetailsModel(ddtResponseData.data);
    } catch (error) {
        console.error("Error fetching DDTs:", error);
        throw error;
    }
}

export async function getDdtsDetailsListAPI(
    documentId: string,
): Promise<DdtDetailsListItemModel[]> {
    try {
        const ddtResponse = await axios.get<DdtsAPIDetailsListResponse>(
            GET_DDT_DETAILS_LIST_API_ENDPOINT(documentId),
        );

        const ddtResponseData = ddtResponse.data;

        if (ddtResponse.status > 200 || !ddtResponseData) {
            throw ddtResponse;
        }

        return ddtResponseData.data.map(
            (constr) => new DdtDetailsListItemModel(constr),
        );
    } catch (error) {
        console.error("Error fetching DDTs:", error);
        throw error;
    }
}
